import { FranchiseType } from "@hubcapp/types";

export const getCapacityLabelsByFranchiseType = (
  franchiseType: FranchiseType,
) => ({
  inputLabel:
    franchiseType === FranchiseType.Dit
      ? "DIT learner capacity"
      : "Learner capacity",
  capacityLabel:
    franchiseType === FranchiseType.Dit
      ? "Current DIT capacity"
      : "Current capacity",
});

export const calculateCapacityProgress = (
  maximumCapacity: number,
  currentCapacity: number,
) =>
  maximumCapacity <= currentCapacity
    ? 100
    : (currentCapacity / maximumCapacity) * 100;
